
import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Summary } from '@/types/civic-education';

interface SummaryFieldsProps {
  item: Summary;
  onFieldChange: (field: keyof Summary, value: any) => void;
}

const SummaryFields = ({ item, onFieldChange }: SummaryFieldsProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="document_url" className="text-sm font-medium">Document URL</label>
        <Input
          id="document_url"
          value={item.document_url}
          onChange={(e) => onFieldChange('document_url', e.target.value)}
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="source" className="text-sm font-medium">Source</label>
        <Input
          id="source"
          value={item.source}
          onChange={(e) => onFieldChange('source', e.target.value)}
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="content" className="text-sm font-medium">Content</label>
        <Textarea
          id="content"
          value={item.content}
          onChange={(e) => onFieldChange('content', e.target.value)}
          required
          rows={6}
        />
      </div>
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="audio_summary"
          checked={item.audio_summary || false}
          onChange={(e) => onFieldChange('audio_summary', e.target.checked)}
        />
        <label htmlFor="audio_summary" className="text-sm font-medium">
          Has Audio Summary
        </label>
      </div>
    </div>
  );
};

export default SummaryFields;
